import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = { class: "ml-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: { path: _ctx.link },
    class: _normalizeClass(_ctx.classNames),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onClick'))),
    style: _normalizeStyle(_ctx.styles),
    custom: ""
  }, {
    default: _withCtx(({ navigate }) => [
      _createElementVNode("button", {
        onClick: navigate,
        style: _normalizeStyle(_ctx.styles),
        class: _normalizeClass(_ctx.classNames)
      }, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.mdiIcon)
            ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 0,
                color: _ctx.styles.color,
                size: _ctx.iconSize
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.mdiIcon), 1)
                ]),
                _: 1
              }, 8, ["color", "size"]))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.text), 1)
        ])
      ], 14, _hoisted_1)
    ]),
    _: 1
  }, 8, ["to", "class", "style"]))
}